import IMG1 from '../../assests/port1.jpg';
import IMG2 from '../../assests/port2.jpg';
import IMG3 from '../../assests/port3.jpg';
import IMG4 from '../../assests/port4.jpg';
import IMG5 from '../../assests/port5.jpg';
import IMG6 from '../../assests/Port6.jpg';

const Pdata=[
{
  img:IMG1,
  title:"Food-Delievery Website",
    link:'https://harshit14319.github.io/Delivery-item/frontindex'

},
{
    img:IMG2,
    title:"Portfollio from HTML,CSS,JAVASCRIPT",
    link:'https://harshit14319.github.io/harshit-porfollio-/login'


},
{
    img:IMG3,
    title:"Survey Website for College",
    link:'https://gym-app-five.vercel.app/'

},
{
    img:IMG4,
    title:"Instagram Login Page",
    link:'https://gym-app-five.vercel.app/'


},
{
    img:IMG5,
    title:"Weather Forecasting",
    link:'https://gym-app-five.vercel.app/'


},
{
    img:IMG6,
    title:"Gym Website ",
  link:'https://gym-app-five.vercel.app/'
  
},
]
export default Pdata;
